module.exports = __webpack_public_path__ + "img/tixian.1a3f9c3a.svg";